import { render, staticRenderFns } from "./child-middle.vue?vue&type=template&id=7b184f74&scoped=true&"
import script from "./child-middle.vue?vue&type=script&lang=ts&"
export * from "./child-middle.vue?vue&type=script&lang=ts&"
import style0 from "./child-middle.vue?vue&type=style&index=0&id=7b184f74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b184f74",
  null
  
)

export default component.exports